module.exports = __webpack_public_path__ + "static/media/012.5de3b128.jpg";